import React, { Component } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Input, Icon, Button, Loader, Dimmer } from 'semantic-ui-react';
import LocationSelector from 'widgets/bussiness/selectors/location-selector';
import EventInstructorsSelector from 'widgets/bussiness/selectors/instructors-selector';
import {
  EventInstructorRole,
  DateTimePeriod,
  EventStatus,
  EventsStore,
  EventDto,
  EventInstructorDto,
  EventUserDto
} from 'stores/events/events-store';
import { ItemReference } from 'stores/dataStore';
import { IdentityService } from 'services/identity-service';
import { resolve } from 'inversify-react';
import ChooseInstructorsView from 'widgets/form/choose-instructors-form';
import EventInstructorRoleEditor from 'widgets/bussiness/event-instructor-role-editor';
import { InstructorExpertiseDto, InstructorExpertiseStore } from 'stores/skills/instructor-expertise-store';
import { connect } from 'redux-scaffolding-ts';
import { DateTimeService } from 'services/datetime-service';
import { RoleInLocationDto, UserDto, UserStore } from 'stores/users/users-store';
import { InstructorStore } from 'stores/instructors/instructors-store';
import AddExpertisePopup from './event-form/popups/add-expertise-popup/add-expertise-popup';
import { MachineListItemViewModel } from '../shared/events-and-requests/machine-list-item';
import { EventTypeDto } from 'stores/configuration/events-workflow/event-types-store';
import PeriodInputTw from 'widgets/form/period-input-tw';

interface TailwindEventPerInstructor {
  event: EventDto;
  instructor: EventInstructorDto;
}

export interface TailwindEventInstructorRow {
  location: ItemReference;
  user: EventUserDto;
  role: EventInstructorRole;
  period: DateTimePeriod;
  workingDays: number;
  workingHours: number;
  notValid?: boolean;
  notInDate?: boolean;
  notConflict?: boolean;
  isNewRow?: boolean;
}

interface EventInstructorsTailwindProps extends WithTranslation {
  onEditMode: boolean;
  showWorkingDays?: boolean;
  instructorRows?: TailwindEventInstructorRow[];
  eventNextStatus?: EventStatus;
  defaultDateFrom: string;
  defaultDateTo: string;
  eventTypeId: string;
  eventType?: EventTypeDto;
  roleId: string;
  machineModelIds: string[];
  functionalSubAreaId: string;
  trainingLevelId: string;
  instructorExpertiseStore?: InstructorExpertiseStore;
  usersStore?: UserStore;
  instructorStore?: InstructorStore;
  isMachineRelated: boolean;
  events?: EventsStore;
  machines: MachineListItemViewModel[];
  onChange?: (instructors: TailwindEventInstructorRow[]) => void;
  instructorBusy?: (busy: boolean) => void;
}

interface EventInstructorsTailwindState {
  intructorSelectorShown: boolean;
  instructorRows: TailwindEventInstructorRow[];
  notConflictOtherEventsDates?: boolean;
  recomendedInstructorsByExpertise: EventUserDto[];
  editingRowIndex: number;
  isBusy: boolean;
  showAddExpertiseModal: boolean;
  instructor: UserDto;
  instructorExpertiseDefined: boolean;
}

interface EventInstructorsTailwindState {}
@connect(
  ['events', EventsStore],
  ['instructorStore', InstructorStore],
  ['usersStore', UserStore],
  ['instructorExpertiseStore', InstructorExpertiseStore]
)
class TailwindEventInstructors extends Component<EventInstructorsTailwindProps, EventInstructorsTailwindState> {
  @resolve(IdentityService)
  private identityService: IdentityService;

  constructor(props: EventInstructorsTailwindProps) {
    super(props);

    this.state = {
      instructorRows: this.props.instructorRows || [],
      intructorSelectorShown: false,
      notConflictOtherEventsDates: false,
      recomendedInstructorsByExpertise: [],
      editingRowIndex: 0,
      isBusy: false,
      showAddExpertiseModal: false,
      instructor: null,
      instructorExpertiseDefined: false
    };
  }

  private isPlannerTFT = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPlannerTFT(userinfo);
  };

  private isPoc = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPoc(userinfo);
  };

  private isPlannerMTC = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPlannerMTC(userinfo);
  };

  private isAdmin = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isAdmin(userinfo);
  };

  private isPlanner = () => {
    const userinfo = this.identityService.getUserInfo();
    return IdentityService.isPlanner(userinfo);
  };

  private buildIsAlredyInstructorExpertiseDefinedFilter(
    instructor: UserDto,
    eventTypeId: string,
    roleId: string,
    trainingLevelId: string,
    machines: MachineListItemViewModel[]
  ) {
    const filters: any[] = [{ IsMachineRelated: { eq: true } }];
    filters.push({ InstructorId: { eq: { type: 'guid', value: instructor.id } } });
    filters.push({ EventTypeId: { eq: { type: 'guid', value: eventTypeId } } });
    filters.push({ RoleId: { eq: { type: 'guid', value: roleId } } });
    filters.push({ TrainingLevelId: { eq: { type: 'guid', value: trainingLevelId } } });

    const machine = machines.firstOrDefault();
    if (machine) {
      if (machine.cluster) filters.push({ MachineRelatedClusterId: { eq: { type: 'guid', value: machine.cluster.id } } });
      if (machine.equipmentType) filters.push({ EquipmentTypeId: { eq: { type: 'guid', value: machine.equipmentType.id } } });
      if (machine.oem) filters.push({ OemId: { eq: { type: 'guid', value: machine.oem.id } } });
      if (machine.machineModel) filters.push({ MachineModelId: { eq: { type: 'guid', value: machine.machineModel.id } } });
    }

    return filters;
  }

  private async IsAlredyInstructorExpertiseDefined(instructor: UserDto) {
    const { isMachineRelated, eventTypeId, roleId, trainingLevelId, machines } = this.props;

    if (!isMachineRelated) return true;
    if ((machines || []).length !== 1) return false;

    let isAlredyInstructorExpertiseDefined: boolean = false;

    const query = {
      searchQuery: '',
      skip: 0,
      take: 100000,
      orderBy: [],
      filter: this.buildIsAlredyInstructorExpertiseDefinedFilter(instructor, eventTypeId, roleId, trainingLevelId, machines || []),
      select: 'id, InstructorId'
    };

    isAlredyInstructorExpertiseDefined = await this.props.instructorExpertiseStore.getAllAsync(query, true).then(instructorExpertises => {
      const instructorsByExpertise = instructorExpertises.items;
      return instructorsByExpertise.length > 0;
    });

    return isAlredyInstructorExpertiseDefined;
  }

  private getInstructor = async (id?: string): Promise<boolean> => {
    try {
      this.setState({
        instructorExpertiseDefined: false,
        instructor: null
      });
      if (id) {
        const instructorData = await this.props.usersStore.getUserById(id);
        const instructorExpertiseDefined = await this.IsAlredyInstructorExpertiseDefined(instructorData);
        this.setState({ instructor: instructorData, instructorExpertiseDefined: instructorExpertiseDefined });
      } else {
        this.setState({ instructor: null, instructorExpertiseDefined: false });
      }
    } catch {
      this.setState({ instructor: null, instructorExpertiseDefined: false });
      return false;
    }
    return true;
  };

  private checkOtherEventsInstructorConflicts(eventsPerInstructor: TailwindEventPerInstructor[]): boolean {
    for (let i = 0; i < eventsPerInstructor.length; i++) {
      if (
        DateTimeService.dateRangeOverlaps(
          DateTimeService.toDateRange(eventsPerInstructor[i].event.startDate, eventsPerInstructor[i].event.endDate),
          DateTimeService.toDateRange(this.props.defaultDateFrom, this.props.defaultDateTo)
        )
      ) {
        return true;
      }
    }

    return false;
  }

  private mapEventInstructorToInstructorExpertise(instructors: TailwindEventInstructorRow[], index: number): InstructorExpertiseDto[] {
    let instructorUsers = instructors.filter(x => !!x.user);
    const instructorRole = {
      role: {
        name: 'Instructor'
      },
      location: {
        id: instructors[index].location.id,
        location: instructors[index].location.title
      }
    } as RoleInLocationDto;
    let instructorExpertises = instructorUsers.map(x => {
      let model = {
        id: x.user.id,
        instructorId: x.user.id,
        user: {
          id: x.user.id,
          roles: [instructorRole]
        }
      };
      return model as InstructorExpertiseDto;
    });

    return instructorExpertises;
  }

  private handleOnEditRow(index) {
    this.setState({
      editingRowIndex: index,
      intructorSelectorShown: true
    });
  }

  private async getInstructorEventsById(id: string) {
    let filters = [{ eventInstructors: { any: [{ InstructorId: { eq: { type: 'guid', value: id } } }] } }];
    let queryEvents = {
      searchQuery: '',
      filter: filters,
      orderBy: [],
      skip: 0,
      take: 100000
    };

    return this.props.events.getAllAsync(queryEvents);
  }

  async getEventInstructorAvailability(newInstructors: InstructorExpertiseDto[], index: number): Promise<TailwindEventInstructorRow[]> {
    if (newInstructors.length > 0) {
      const instructorId = newInstructors[index].instructorId;
      let eventsInstructors = await this.getInstructorEventsById(instructorId).then(events => this.mapToEventInstructor(events.items));

      let finalEvents = eventsInstructors.filter(x => x.instructor.instructorId === instructorId);

      let newInstructorRows = newInstructors.map((instructorExpertise: InstructorExpertiseDto) => {
        let newInstructorRow: TailwindEventInstructorRow = {
          location: {
            id: instructorExpertise.user.roles.find(({ role }) => role.name === 'Instructor')
              ? instructorExpertise.user.roles.find(({ role }) => role.name === 'Instructor')?.location?.id
              : '0',
            title: instructorExpertise.user.roles.find(({ role }) => role.name === 'Instructor')
              ? instructorExpertise.user.roles.find(({ role }) => role.name === 'Instructor')?.location?.location
              : ''
          },
          period: {
            from: this.props.defaultDateFrom,
            to: this.props.defaultDateTo
          },
          role: undefined,
          user: instructorExpertise.user,
          workingDays: null,
          workingHours: null,
          notValid: false,
          notInDate: false,
          notConflict: false
        };

        newInstructorRow.notValid = !this.isRecommendedInstructorToValided(newInstructorRow);
        newInstructorRow.notConflict = this.checkOtherEventsInstructorConflicts(finalEvents);

        return newInstructorRow;
      });
      return newInstructorRows;
    }
  }

  async handleInstructorChange(user: EventUserDto, index: number) {
    this.props.instructorBusy(true);
    let instructors = this.props.instructorRows;
    instructors[index].user = user;
    this.setState({ showAddExpertiseModal: true });
    await this.getInstructor(instructors[index].user?.id);
    if (instructors && instructors.length > 0 && instructors.some(x => !!x.user)) {
      if (!instructors[index].location) {
        instructors[index].location = {} as ItemReference;
        instructors[index].location.id = user.location.id;
        instructors[index].location.title = user.location.location;
      }
      let instructorExpertises = this.mapEventInstructorToInstructorExpertise(instructors, index);
      let eventInstructors = await this.getEventInstructorAvailability(instructorExpertises, index);
      if (eventInstructors && eventInstructors.length > 0) {
        instructors[index].notConflict = eventInstructors[index].notConflict;
        instructors[index].notValid = eventInstructors[index].notValid;
      }
    }
    this.props.instructorBusy(false);
    this.raiseOnChange(instructors);
  }

  componentDidMount() {
    let query = {
      searchQuery: '',
      skip: 0,
      take: 100000,
      orderBy: [],
      filter: this.buildODataQueryFilter()
    };

    this.props.instructorBusy(true);

    this.props.instructorStore
      .getAllAsync(query)
      .then(instructor => {
        let recomendedInstructors: EventUserDto[] = instructor.items.map(x => ({
          firstName: x.name,
          id: x.userId,
          lastName: x.surname,
          location: x.location,
          pillar: x.pillar,
          isPowerInstructor: x.isPowerInstructor
        }));

        this.setState({
          recomendedInstructorsByExpertise: recomendedInstructors
        });
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        this.props.instructorBusy(false);
      });
  }

  private buildODataQueryFilter() {
    const filters: any[] = [];
    if (this.isPoc()) {
      filters.push({ instructorRole: { name: { eq: 'Internal Trainer' } } });
    }

    const usr = this.identityService.getUserInfo();
    const activeRole = usr.activeRole;
    if (activeRole === 'Instructor') {
      const isPowerInstructor = IdentityService.isPowerInstructor(this.identityService.getUserInfo());
      if (isPowerInstructor) {
        const pillar = this.identityService.getCurrentUserDto()?.pillar;
        filters.push({ PillarId: { eq: { value: pillar.id, type: 'guid' } } });
      } else {
        filters.push({ id: { eq: { type: 'guid', value: usr.userId.toString() } } });
      }
    }

    return filters;
  }

  OnSelectedIntructorClose() {
    this.setState({ intructorSelectorShown: false });
  }

  mapToEventInstructor(events: EventDto[]) {
    let eventsPerInstructor: TailwindEventPerInstructor[] = [];
    events.forEach(event =>
      eventsPerInstructor.push(
        ...event.instructors.map(instructor => ({
          event: event,
          instructor: instructor
        }))
      )
    );
    return eventsPerInstructor;
  }

  onSelectedInstructor = async (newInstructors: InstructorExpertiseDto[]) => {
    if (newInstructors.length <= 0) {
      return;
    }
    this.setState({ isBusy: true });
    this.props.instructorBusy(true);
    const newInstructorRows = await this.getEventInstructorAvailability(newInstructors, 0);

    let instructors = { ...this.props.instructorRows };
    if (this.state.editingRowIndex && instructors) {
      instructors = [
        ...instructors.slice(0, this.state.editingRowIndex),
        ...newInstructorRows,
        ...instructors.slice(this.state.editingRowIndex + 1, instructors.length)
      ];
      this.setState({ editingRowIndex: null });
    } else instructors = [...(this.props.instructorRows || []), ...newInstructorRows];

    this.raiseOnChange(instructors);
    this.setState({ isBusy: false });
    this.props.instructorBusy(false);
  };

  renderInstructor(instructor: TailwindEventInstructorRow, index: number): React.ReactNode {
    if (!this.props.onEditMode)
      return <Input className="w-full" transparent readOnly value={instructor.user.firstName + ' ' + instructor.user.lastName} />;

    const usr = this.identityService.getUserInfo();
    const activeRole = usr.activeRole;

    if (!instructor.user || this.isRecommendedInstructor(instructor)) {
      return (
        <EventInstructorsSelector
          className="w-full"
          value={instructor.user ? instructor.user.id : null}
          locationId={instructor.location ? instructor.location.id : null}
          onChange={user => {
            this.handleInstructorChange(user, index);
            if (user && user.location) {
              this.handleLocationChange({ id: user.location.id, title: user?.location?.location }, index);
            }
            if (activeRole === 'Instructor' && !user.isPowerInstructor) {
              const eventInstructorRole: EventInstructorRole = EventInstructorRole[EventInstructorRole.Lead.toString()];
              this.handleInstructorRoleChange(eventInstructorRole, index);
            }
          }}
          options={this.state.recomendedInstructorsByExpertise}
          onlyInstructorsPlannerTFT={this.isPlannerTFT()}
          onlyInstructorsPlannerMTC={this.isPlannerMTC()}
        />
      );
    }

    return (
      <EventInstructorsSelector
        readOnly
        className="w-full"
        value={instructor.user ? instructor.user.id : null}
        options={[instructor.user]}
        onlyInstructorsPlannerTFT={this.isPlannerTFT()}
        onlyInstructorsPlannerMTC={this.isPlannerMTC()}
      />
    );
  }

  isRecommendedInstructorToValided(instructor: TailwindEventInstructorRow): boolean {
    if (!instructor.user) return false;
    else return !!this.state.recomendedInstructorsByExpertise.find(x => x.id === instructor.user.id);
  }

  isRecommendedInstructor(instructor: TailwindEventInstructorRow): boolean {
    return !!this.state.recomendedInstructorsByExpertise.find(x => x.id === instructor.user.id);
  }

  renderInstructorRole(instructor: TailwindEventInstructorRow, index: number): React.ReactNode {
    if (!this.props.onEditMode)
      return <Input className="w-full" transparent readOnly value={EventInstructorRole[EventInstructorRole[instructor.role]]} />;

    return (
      <EventInstructorRoleEditor
        key={`roleeditor-${instructor.role ? instructor.role.toString() : 'undefined'}-${index}`}
        className="w-full"
        value={instructor.role}
        onChange={role => this.handleInstructorRoleChange(role, index)}
      />
    );
  }

  renderLocation(instructor: TailwindEventInstructorRow, index: number): React.ReactNode {
    if (!this.props.onEditMode) return <input className="w-full" readOnly value={instructor.location ? instructor.location.title : ''} />;

    if (!instructor.user || this.isRecommendedInstructor(instructor))
      return (
        <LocationSelector
          className="w-full"
          value={instructor.location ? instructor.location.id : null}
          nullable
          clearable
          onChangeLocation={location => {
            this.handleLocationChange(location, index);
            if (!location) this.handleInstructorChange(undefined, index);
          }}
        />
      );

    return <LocationSelector className="w-full" value={instructor.location ? instructor.location.id : null} readOnly />;
  }

  handleLocationChange(location: ItemReference, index: number): void {
    let instructors = this.props.instructorRows;
    instructors[index].location = location;
    this.raiseOnChange(instructors);
  }

  handleInstructorRoleChange(role: EventInstructorRole, index: number): void {
    let instructors = this.props.instructorRows;
    instructors[index].role = role;

    this.raiseOnChange(instructors);
  }

  handleOnRemoveInstructor(instructor: TailwindEventInstructorRow, index: number) {
    let instructors = this.props.instructorRows.filter((x, i) => index !== i);

    this.raiseOnChange(instructors);
  }

  handleWorkingHoursChange(workingHours: string, index: number): void {
    let instructors = this.props.instructorRows;
    instructors[index].workingHours = +workingHours;

    this.raiseOnChange(instructors);
  }

  handlePeriodChange(period: DateTimePeriod, index: number) {
    let instructors = this.props.instructorRows;
    instructors[index].period = period;

    if (
      DateTimeService.toMoment(instructors[index].period.from).isBefore(this.props.defaultDateFrom, 'day') ||
      DateTimeService.toMoment(instructors[index].period.from).isAfter(this.props.defaultDateTo, 'day') ||
      DateTimeService.toMoment(instructors[index].period.to).isBefore(this.props.defaultDateFrom, 'day') ||
      DateTimeService.toMoment(instructors[index].period.to).isAfter(this.props.defaultDateTo, 'day')
    )
      instructors[index].notInDate = true;
    else instructors[index].notInDate = false;

    this.raiseOnChange(instructors);
  }

  handleWorkingDaysChange(workingDays: string, index: number): void {
    let instructors = this.props.instructorRows;
    instructors[index].workingDays = +workingDays;

    this.raiseOnChange(instructors);
  }

  canEditWorkingTime(instructor: TailwindEventInstructorRow) {
    return (
      this.props.eventNextStatus &&
      this.props.eventNextStatus.toString() === 'Closed' &&
      instructor.user &&
      instructor.user.id === this.identityService.userId
    );
  }

  addInstructorRow(): void {
    let emptyInstructorRow: TailwindEventInstructorRow = {
      location: null,
      period: {
        from: this.props.defaultDateFrom.toString(),
        to: this.props.defaultDateTo.toString()
      },
      role: null,
      user: null,
      workingDays: null,
      workingHours: null,
      isNewRow: true
    };

    let instructors = [...(this.props.instructorRows || []), emptyInstructorRow];

    this.raiseOnChange(instructors);
  }

  raiseOnChange(instructors: TailwindEventInstructorRow[]) {
    if (!this.props.onChange) return;

    this.setState({ instructorRows: instructors });

    this.props.onChange(instructors);
  }

  private hideAddInstructorExpertiseModal = () => {
    this.setState({ showAddExpertiseModal: false, instructor: null });
  };

  private handleOnAddInstructorExpertise = () => {
    this.hideAddInstructorExpertiseModal();
  };

  render() {
    const { t, isMachineRelated } = this.props;
    const instructors = this.state.instructorRows || [];
    const { showAddExpertiseModal, instructor, instructorExpertiseDefined } = this.state;
    return (
      <>
        <Dimmer active={this.state.isBusy} inverted>
          <Loader indeterminate inverted />
        </Dimmer>
        <div className="mb-3">
          {!this.props.instructorStore.state.isBusy && (
            <div className="form__instructors-tab__buttons-row">
              <div className="instructors-tab__add-instructor-button">
                {this.props.onEditMode && (
                  <Button
                    labelPosition="right"
                    icon="user plus"
                    content={t('Add instructor')}
                    className="form__add-instructor-btn-event-creation"
                    onClick={() => this.addInstructorRow()}
                  />
                )}
              </div>
            </div>
          )}

          <div className="mb-3">
            {(this.props.instructorStore.state.isBusy || this.props.usersStore.state.isBusy || this.props.events.state.isBusy) && (
              <Dimmer active inverted>
                <Loader size="large" active inverted />
              </Dimmer>
            )}

            {!this.props.instructorStore.state.isBusy &&
              instructors &&
              instructors.length > 0 &&
              instructors.map((instructor, index) => (
                <React.Fragment key={`instructor-${instructor.location ? instructor.location.title : 'undefined'}-${index}`}>
                  <div className="border border-gray-300 rounded shadow-sm hover:shadow-md mb-8 relative p-4 pb-8 bg-gray-50">
                    <div className="instructors__edit-icon__container">
                      {instructor.isNewRow ? null : (
                        <Icon className="clickable-icon" name="edit" size="large" onClick={() => this.handleOnEditRow(index)} />
                      )}
                    </div>

                    {this.props.onEditMode && (
                      <>
                        <div className="instructors__delete-icon__container absolute right-0" style={{ bottom: '-8px', zIndex: 20 }}>
                          <span
                            className="clickable-icon"
                            style={{ display: 'inline-flex', cursor: 'pointer' }}
                            role="button"
                            tabIndex={0}
                            aria-label="Remove"
                            onClick={() => this.handleOnRemoveInstructor(instructor, index)}
                            onKeyPress={e => {
                              if (e.key === 'Enter' || e.key === ' ') {
                                this.handleOnRemoveInstructor(instructor, index);
                              }
                            }}
                          >
                            <svg
                              className="w-6 h-6"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              width="24"
                              height="24"
                              fill="none"
                              viewBox="0 0 24 24"
                            >
                              <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M5 7h14m-9 3v8m4-8v8M10 3h4a1 1 0 0 1 1 1v3H9V4a1 1 0 0 1 1-1ZM6 7h12v13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V7Z"
                              />
                            </svg>
                          </span>{' '}
                          <div style={{ height: '10px' }} />
                        </div>
                      </>
                    )}

                    <div>
                      <label>{t("Instructor's Location")}</label>
                      <div>{this.renderLocation(instructor, index)}</div>
                    </div>

                    <div>
                      <label>{t("Instructor's Name")}</label>
                      <div>{this.renderInstructor(instructor, index)}</div>
                    </div>

                    <div>
                      <label>{t('Role')}</label>
                      <div>{this.renderInstructorRole(instructor, index)}</div>
                    </div>

                    <div>
                      <label> {t('Period per Instructor')}</label>
                      <div className="required field mb-3">
                        <PeriodInputTw
                          id={`event-wizard-instructor-${index}`}
                          iconPosition="right"
                          minMaxDate
                          readOnly={!this.props.onEditMode}
                          value={instructor.period}
                          onChange={value => this.handlePeriodChange(value, index)}
                        />
                      </div>
                    </div>
                    <div style={{ height: '10px' }} />
                  </div>
                </React.Fragment>
              ))}
          </div>

          {this.state.intructorSelectorShown && (
            <ChooseInstructorsView
              alreadySelected={this.state.instructorRows}
              onSelectInstructors={this.onSelectedInstructor}
              onCloseModal={() => this.setState({ intructorSelectorShown: false })}
              onlyInstructorsPlannerTFT={this.isPlannerTFT()}
              onlyInstructorsPlannerMTC={this.isPlannerMTC()}
            />
          )}

          {(this.isAdmin() || this.isPlanner()) &&
            isMachineRelated &&
            showAddExpertiseModal &&
            instructor &&
            !instructor.isPowerInstructor &&
            !instructorExpertiseDefined && (
              <AddExpertisePopup
                machines={this.props.machines || []}
                open={showAddExpertiseModal}
                onSuccess={this.handleOnAddInstructorExpertise}
                onCancel={this.hideAddInstructorExpertiseModal}
                instructorIds={instructor}
                eventTypeId={this.props.eventTypeId}
                roleId={this.props.roleId}
                trainingLevelId={this.props.trainingLevelId}
                originalEventTypeId={this.props.eventType.originalEventTypeId}
              />
            )}
        </div>
      </>
    );
  }
}

export default withTranslation()(TailwindEventInstructors);
